import React from 'react'
import classnames from 'classnames'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import RelatedContent from '../../relatedcontent'
import styles from './styles'

const Linker = withStyles(styles)(props => {
  const { contents, type, inc, count, classes } = props
  const data = contents.filter(x => x.type === type)[count[type]].content
  inc(type)
  return (
    data && (
      <div className={classes.page}>
        <div className={classes.contents}>
          <div className={classes.linker}>
            <div className={classnames(classes.layout, classes.margins)}>
              {data.primary && (
                <Grid container spacing={40}>
                  <Grid item xs={12}>
                    <Typography variant="headline">
                      {data.primary.title1.text}
                    </Typography>
                    <Typography variant="subheading">
                      {data.primary.subtitle1.text}
                    </Typography>
                  </Grid>
                </Grid>
              )}
              <div className={classes.margins}>
                <RelatedContent content={data} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  )
})

export default withStyles(styles)(Linker)



// WEBPACK FOOTER //
// ./src/components/scaffolding/widgets/linker.js